module.exports = __webpack_public_path__ + "static/media/iphone_acc_dark.9ee8412f.svg";